import { NothingMessage, useThemeContext } from '@gravitate-js/excalibrr'
import { Popover, Spin } from 'antd'
import classNames from 'classnames'
import GoogleMapReact from 'google-map-react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { getFlagsStatus } from '../../_SiteWide/Flags/FlagIcon'
import { darkMapTheme } from '../../_SiteWide/Theming/darkMapTheme'
import { useSiteMonitoringContext } from '../SiteMonitoringContext'
import { StorePopover } from './StorePopover'

export function SiteMap({ highlightedStore, mapCenter, zoom = 11, stores = [], rundownToggled }) {
  const { isDarkTheme } = useThemeContext()
  const { loading } = useSiteMonitoringContext()
  const [mapsApi, setMapsApi] = useState(null)
  const [map, setMap] = useState(null)

  const zoomToFitMarkers = () => {
    if (!mapsApi || !map) return
    const bounds = new mapsApi.LatLngBounds()
    stores.forEach((store) => {
      bounds.extend(new mapsApi.LatLng(store.location.lat, store.location.lng))
    })
    map.fitBounds(bounds)
  }

  useEffect(() => {
    zoomToFitMarkers()
  }, [stores])

  const handleMapLoad = ({ map, maps }) => {
    setMap(map)
    setMapsApi(maps)
  }

  if (loading)
    return (
      <div className='google-map-container loading-map-container vertical-flex-center flex-1'>
        <Spin size='large' />
      </div>
    )

  if (!loading && stores.length === 0)
    return (
      <div className='google-map-container loading-map-container flex-1'>
        <NothingMessage title='No Sites Found' message='No sites were found with the current selected filters' />
      </div>
    )

  return (
    <div className='flex-1' style={{ marginLeft: '-15px' }}>
      <GoogleMapReact
        className='google-react-map'
        bootstrapURLKeys={{ key: 'AIzaSyAHRw5QAytXdYMpHewQavKETUnKs79pqnw' }}
        center={mapCenter}
        zoom={stores.length > 200 ? zoom : zoom - 1}
        yesIWantToUseGoogleMapApiInternals
        options={isDarkTheme && darkMapTheme}
        onGoogleApiLoaded={handleMapLoad}
      >
        {stores?.map((store) => {
          return (
            <MapMark
              isDark={isDarkTheme}
              key={store?.store_number}
              highlight={store?.store_number === highlightedStore}
              store={store}
              lat={store?.location?.lat}
              lng={store?.location?.lng}
              rundownToggled={rundownToggled}
            />
          )
        })}
      </GoogleMapReact>
    </div>
  )
}
function MapMark({ store, highlight, isDark, rundownToggled }) {
  const [isHovered, setIsHovered] = useState(false)
  const alertClass = getFlagsStatus(store)
  const navigate = useNavigate()
  return (
    <Popover
      overlayStyle={{ borderRadius: 20 }}
      content={
        <StorePopover
          key={store.store_number}
          rundownToggled={rundownToggled}
          {...store.location}
          store={store}
          placement='top'
        />
      }
    >
      <div style={{ color: alertClass === 'error' ? 'red' : '#002766' }}>
        <div
          onClick={() => navigate(`/site_monitoring/${store.id}`)}
          className={classNames('map-mark-icon', alertClass, { big: highlight }, { dark: isDark })}
        />
      </div>
    </Popover>
  )
}
